import React, { ReactNode } from 'react';

import { Select } from 'antd';
import {
  FlagIconFR,
  FlagIconGF,
  FlagIconGP,
  FlagIconMQ,
  FlagIconRE,
  FlagIconYT,
} from '@flagkit/react';
import styled from 'styled-components';

const { Option } = Select;

interface NonRestrictedCountryType {
  apiCountryLabel: string;
  displayName?: string;
  flag: ReactNode;
}

interface PlacesAutocompleteAddonType {
  defaultValue?: string;
  onChange: (value: string) => void;
  value?: string;
}

const nonRestrictedCountries: NonRestrictedCountryType[] = [
  {
    apiCountryLabel: 'France',
    displayName: 'France Métropolitaine',
    flag: <FlagIconFR />,
  },
  { apiCountryLabel: 'Guadeloupe', flag: <FlagIconGP /> },
  { apiCountryLabel: 'Martinique', flag: <FlagIconMQ /> },
  { apiCountryLabel: 'Mayotte', flag: <FlagIconYT /> },
  {
    apiCountryLabel: 'French Guiana',
    displayName: 'Guyane',
    flag: <FlagIconGF />,
  },
  { apiCountryLabel: 'Réunion', flag: <FlagIconRE /> },
];

export const PlacesAutocompleteAddon: React.FC<PlacesAutocompleteAddonType> = ({
  defaultValue,
  onChange,
  value,
}) => {
  return (
    <StyledSelect
      defaultValue={defaultValue}
      dropdownMatchSelectWidth={false}
      onChange={value => onChange(value as string)}
      optionLabelProp="label"
      value={value}
    >
      {nonRestrictedCountries.map(
        (country: NonRestrictedCountryType, index: number) => (
          <Option
            key={index}
            value={country.apiCountryLabel}
            label={country.flag}
          >
            {country.flag}{' '}
            {country.displayName
              ? country.displayName
              : country.apiCountryLabel}
          </Option>
        )
      )}
    </StyledSelect>
  );
};

const StyledSelect = styled(Select)`
  &:not(.ant-select-customize-input) {
    .ant-select-selector {
      align-items: center;
      height: 100%;
    }
  }
`;
